import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-employees-importer',
  templateUrl: './employees-importer.component.html',
  styleUrls: ['./employees-importer.component.css']
})
export class EmployeesImporterComponent implements OnInit {

  constructor() { }

  ngOnInit() {}
}
